import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import store from "@/store";
import { onBeforeMount, onMounted, ref, watch } from "vue";
import { getUser, removeUser } from "@/common/services/user";
import { userProfile } from "@/common/api/rest/user";

import { PanelTheme } from "@/common/themes";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isMobile = ref(false);

function fecthProfile() {
  userProfile().then((response) => {
    const { success, data, code } = response;
    if (success) {
      store.commit("SET_PROFILE", data);
    } else {
      if (code === 401) removeUser();
    }
  });
}

onBeforeMount(() => {
  const user = getUser();
  if (!user) {
    removeUser();
    return;
  }

  fecthProfile();
  store.commit("SET_USER", user);
  store.commit("SET_LOGGED", true);
});

watch(
  () => isMobile.value,
  () => {
    store.commit("SET_MOBILE", isMobile.value);
  }
);

onMounted(() => {
  isMobile.value = window.innerWidth < 1024;

  window.addEventListener("resize", () => {
    isMobile.value = window.innerWidth < 1024;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(store).getters.logged)
    ? (_openBlock(), _createBlock(_unref(PanelTheme), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}
}

})